module.exports = __webpack_public_path__ + "img/main-list_06.00c48537.jpg";